import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { Trophy, RotateCcw, Home, X } from "lucide-react";
import confetti from "canvas-confetti";

const fire = () => {
  try {
    const colors = ["#10B981", "#FBBF24", "#ffffff", "#38BDF8"];
    confetti({ particleCount: 180, spread: 100, startVelocity: 50, origin: { y: 0.45 }, colors, zIndex: 100000 });
    setTimeout(() => confetti({ particleCount: 100, angle: 60, spread: 75, origin: { x: 0, y: 0.7 }, colors, zIndex: 100000 }), 200);
    setTimeout(() => confetti({ particleCount: 100, angle: 120, spread: 75, origin: { x: 1, y: 0.7 }, colors, zIndex: 100000 }), 200);
  } catch { /* no-op */ }
};

// Full-screen win moment: big +£, confetti, what they won, then play again or go home.
const WinCelebration = ({ open, amount, label, onClose, onAgain, againLabel = "Play again" }) => {
  const navigate = useNavigate();
  useEffect(() => { if (open) fire(); }, [open]);
  if (!open) return null;
  // Portal to <body> so a transformed ancestor (e.g. .pop-in card) can't trap the fixed overlay.
  return createPortal(
    <div data-testid="win-celebration" className="fixed inset-0 z-[9999] flex items-center justify-center p-6 bg-[#022C22]/90 backdrop-blur-md">
      <button data-testid="win-celebration-close" onClick={onClose} aria-label="Close" className="absolute top-5 right-5 z-10 rounded-full bg-white/10 p-2 text-white hover:bg-white/20"><X className="w-5 h-5" /></button>
      <div className="w-full max-w-sm text-center text-white pop-in">
        <div className="mx-auto w-20 h-20 rounded-full bg-[#FBBF24] flex items-center justify-center shadow-[0_0_40px_rgba(251,191,36,0.6)]">
          <Trophy className="w-10 h-10 text-[#0F172A]" strokeWidth={2.5} />
        </div>
        <div className="mt-5 text-sm label-eyebrow text-[#6EE7B7]">You won!</div>
        <div data-testid="win-celebration-amount" className="font-display font-black text-8xl leading-none tabular mt-1 text-[#FBBF24] drop-shadow-[0_4px_20px_rgba(251,191,36,0.45)]">+£{Number(amount || 0).toLocaleString()}</div>
        <p data-testid="win-celebration-label" className="mt-3 text-lg font-semibold">{label}</p>
        <p className="text-xs text-[#A7F3D0]/70 mt-1">Added to your balance (virtual £)</p>
        <div className="mt-7 space-y-2.5">
          {onAgain && (
            <button data-testid="win-celebration-again" onClick={() => { onClose(); onAgain(); }} className="btn-green w-full rounded-xl py-4 font-extrabold uppercase text-lg flex items-center justify-center gap-2">
              <RotateCcw className="w-5 h-5" /> {againLabel}
            </button>
          )}
          <button data-testid="win-celebration-home" onClick={() => navigate("/")} className="w-full rounded-xl py-3.5 font-bold border border-white/25 bg-white/10 hover:bg-white/15 flex items-center justify-center gap-2">
            <Home className="w-5 h-5" /> Home
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default WinCelebration;
